import styled from "styled-components";
export const RouteLayout = styled.div`
  min-height: 100vh;
`;
